import { PillButton } from "@NP-Webber/crm-kit";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import "../styles/authTheme.css";

export function NoTenantAccessPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await auth.logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="auth-gate-page">
      <div className="auth-gate-card">
        <h1>אין לך גישה לארגון פעיל</h1>
        <p>
          המשתמש מחובר, אך אין עבורו חברות בארגון פעיל. פנו למנהל המערכת לקבלת
          גישה.
        </p>
        <PillButton onClick={handleLogout}>התנתק</PillButton>
      </div>
    </div>
  );
}

export default NoTenantAccessPage;
